ht.log = function () {
  try {
    //debugger;
    console.log.apply(console, arguments);
  } catch (e) {
    ht.log = function () {};
    // do nothing. console not available
  }
};
